import { Container, Row, Col } from 'react-bootstrap';
import Box from "../Home/Box.jsx"

export default function NoPageFound() {
  return (
    <div className="home-wrapper">
      <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
        <Row>
          <Col>
            <Box title="No Page Found" description="Sorry, we weren't able to find a page by that name..." />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
